import { ParameterType } from '@/study-search/enums';

import { FilterDefinition } from './FilterDefinition';
import { AreaFilterOptionInformation } from '@studyportals/search-filters';
import AreaFilterOptionInformationFactory from '../filter/location/area/AreaFilterOptionInformationFactory';

class AreaFilterDefinition extends FilterDefinition {
	public constructor() {
		super(
			ParameterType.AREA,
			AreaFilterOptionInformationFactory.getAreaFilterInformation(),
			AreaFilterOptionInformationFactory.getAreaFilterOptionValues(),
		);
	}

	public getCountryId(areaId: string): string {
		const areaInformation = this.getAreaInformation(areaId);

		return areaInformation.countryIdentity;
	}

	public getAreas(countryId: string): string[] {
		return (this.filterInformation as AreaFilterOptionInformation[])
			.filter((_) => _.countryIdentity === countryId)
			.map((_) => _.optionValue);
	}

	private getAreaInformation(areaId: string): AreaFilterOptionInformation {
		return (this.filterInformation as AreaFilterOptionInformation[]).filter((_) => _.optionValue === areaId)[0];
	}
}

export default new AreaFilterDefinition();
